import { makeStyles } from '@mui/styles';
import colors from "../../../../../../common/styles/colors";

export const useTableToolbarSelectStyles = makeStyles({
  container: {
    background: colors.primary,
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "8px 15px",
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6
  },
  leftContainer: {
    color: colors.white
  },
  button: {
    color: colors.white,
    display: "flex",
    alignItems: "center",
    textTransform: "capitalize",
    "& span": {
      marginLeft: 5
    }
  },
  printButton: {
    color: colors.primary,
    backgroundColor: colors.white,
    "&:hover": {
      backgroundColor: colors.white
    }
  },
  actionButtons: {
    display: "flex"
  }
});
